export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10739.7b67bd33.jpg";